import * as React from "react";

import "./edit-form.scss";

import {cs}              from "@Common/react/chain-services";
import {consumeContext}  from "@Common/react/context";
import {Load2}           from "@Common/react/load2";
import {UseState}        from "@Common/react/use-state";
import {EditFormField}   from "@Common/tools/cc-integration/ui/edit-form-field/edit-form-field";
import {EditQrField}     from "@Common/tools/cc-integration/ui/edit-qr-field/edit-qr-field";
import {rColorLineTiles} from "@Common/ui-components/color-picker/color-tiles";
import {AlertModal}      from "@Common/ui-components/heavy/common/design2/dialogs/alert-modal/alert-modal";

export const EditForm = ({cc, disableSaves, advEditMode, itemId, distributionType, itemSaver}) => cs(
    consumeContext("apis"),
    consumeContext("templateOptions"),
    ["variableData", ({apis, templateOptions}, next) => Load2({
        fetch: async () => templateOptions?.allowVariableData
            && distributionType === "mailing"
            && await apis.next.templateAdmin.getVariableDataMergeFields(),
        next
    })],
    ["alertModal", ({}, next) => AlertModal({next})],
    ["textFields", (_, next) => cc.loadTextFields({side: cc?.currentSide, next})],
    ({alertModal, textFields, variableData, templateOptions}) => {
        let hasColorScheme = false;
        if(cc?.initialized && cc?.ccConfig?.colorSet && Object.keys(cc.ccConfig.colorSet).length
            && cc?.ccConfig?.styleBindingData?.[cc.currentSide] && Object.keys(cc.ccConfig.styleBindingData[cc.currentSide]).length) {
            Object.values(cc.ccConfig.styleBindingData[cc.currentSide]).some((values)=>{
                let tags = values?.tags ?? [];
                let index = tags.findIndex(tag => tag.startsWith('color'));
                if(index !== -1){
                    hasColorScheme = true;
                }
                return hasColorScheme;
            })
        }
        return (
            <div
                className="edit-form edit-form-139"
                style={{
                    ...advEditMode && cc?.currentSide && (
                        !Object.keys(cc.ccConfig?.styleConfigurations?.[cc.currentSide]).length && !hasColorScheme
                    ) && ({
                        display: "none",
                    })
                }}
            >

                <div className="fields" style={ advEditMode ? {marginBottom: "-20px", } : {} }>
                    { cc?.currentSide && cc.ccConfig?.styleConfigurations?.[cc.currentSide]
                    && Object.keys(cc.ccConfig.styleConfigurations[cc.currentSide]).map( (style) =>(
                        //hide styles if they are set from pickpack variations.
                        !cc.pickpackStyleSelections?.[cc.currentSide]?.[style] ? <div
                            className="form-group field-editor-383"
                            key={style}
                            data-side={cc.currentSide}
                            style={ advEditMode ? {display: 'inline-block', paddingRight: "10px", } : {} }
                        >
                            <div className="control-label">
                                {style}
                            </div>
                            <select className={`${cc.currentSide}-${style}`} key={`${cc.currentSide}-${style}`}
                                    defaultValue={cc.inputData?.styles?.[cc.currentSide]?.[style]
                                        ? cc.inputData.styles[cc.currentSide][style]
                                        : cc.ccConfig.styleDefaults?.[cc.currentSide]?.[style]
                                            ? cc.ccConfig.styleDefaults[cc.currentSide][style]
                                            : ''
                                    }
                                    xd-qa-type="dropdown"
                                    onChange={(e) =>{
                                        if(e.target.value){
                                            cc.applyTheme(e.target.value);
                                            cc.setStyle(cc.currentSide, cc.ccConfig.styleConfigurations[cc.currentSide][style][e.target.value], style, e.target.value);
                                        }
                                    }}
                            >
                                <option value='' xd-qa-type='dropdown_item'/>

                                {Object.values(cc.ccConfig.stylesIndexed[cc.currentSide][style] ?? {}).map((subStyle) => (
                                    <option value={subStyle.optionName} key={subStyle.optionName} xd-qa-type='dropdown_item'>
                                        {subStyle.optionName.replace(`${cc.currentSide}-`,'')}
                                    </option>
                                ))}
                            </select>
                        </div> : <></>
                    ))}
                    {hasColorScheme && (
                        <div className={advEditMode? "form-group": "color-scheme form-group"} style={ Object.keys(cc.ccConfig.colorSet).length == 1 ? {visibility: "hidden", position: "absolute"} : null }>
                            <div className="control-label">Color Scheme</div>
                            {rColorLineTiles(cc)}
                        </div>
                    )}

                    {!advEditMode && cc.qrFields && cc.qrFields.filter((qf) => qf.side === cc?.currentSide).map((qrField) =>
                        cs(
                            ["show", (_, next) => UseState({next})],
                            ({show}) => (
                                <div
                                    className="form-group field-editor-383 qr-field-9do" key={qrField.id}
                                    data-side={qrField.side}
                                >
                                    <div className="control-label qr-label" onClick={() => show.onChange(!show.value)}>
                                        QR Code {qrField?.isRequired ? <span style={{color: "red"}}> *</span>:''}
                                        <i className={show.value ? "fa fa-chevron-down": "fa fa-chevron-up"} xd-qa-type="icon"/>
                                    </div>
                                    <EditQrField qrField={qrField} cc={cc} disableSaves={disableSaves} itemId={itemId} itemSaver={itemSaver} show={!show.value}/>
                                </div>
                            )
                        )
                    )}

                    {!advEditMode && !variableData?.loading && textFields?.map((textField) => (
                        <div
                            className="form-group field-editor-383"
                            key={textField.id}
                            data-side={textField.side}
                        >
                            {textField.type !== "hidden" && !textField.locked && (
                                <div className="control-label">
                                    {textField.label}
                                    {textField.isRequired && <span style={{color: "red"}}> *</span>}
                                </div>
                            )}
                            {EditFormField({
                                textField,
                                cc,
                                findTf: (name) => textFields.find((tf) => tf.name === name),
                                allowSuggestedComments: cc.ccConfig.templateConfigurations[textField.side]?.[textField.name]?.useSuggested ? true : false,
                                xdQaName: textField.label,
                                variableData: variableData.value,
                                itemId
                            })}
                        </div>
                    ))}

                </div>

                {cc.renderBlockSelectingReadonlyText({
                    onSelect: () => alertModal.show({message: <p>This field is not editable in the canvas.<br/>Please use the text fields in the form to edit this field.</p>}),
                })}

            </div>
        )
    }
);